import {PictureSetting} from "../../common/constants/pictureSettings";
import {getAltText, getPictureUri} from "./CCOPicture";
import {CmPicture} from "../../../packages/graphql-layer/src";
import Image from "next/image";
import React from "react";
import {isOldIpad} from "../../utility/userAgent";


export interface Props {
    pictureSetting: PictureSetting,
    picture: CmPicture,
    className?: string,
    alt?: string,
    pictureStyle?: any
    imageStyle?: any
    hasPriority?: boolean
    dataCypress?: string
}

const CCOResponsivePicture = (props: Props) => {
    const sources = createSources(props.picture, props.pictureSetting);
    return (
        <picture className={props.className || ""} style={props.pictureStyle}>
            {!isOldIpad() && sources.map((source, index) => {
                return source && <source key={index} media={source.media} srcSet={source.srcset}/>;
            })}
            {renderImage(props)}
        </picture>
    )
}

function createSources(picture: CmPicture, pictureSetting: PictureSetting) {
    return pictureSetting.sources
        // The list of sources needs to be sorted downwards.
        // The browser will go top down.
        // The first source tag that returns true (media query) will be displayed.
        .sort((a, b) => b.minWidthBreakpoint! - a.minWidthBreakpoint!)
        .map(source => {
            return {
                media: "(min-width: " + source.minWidthBreakpoint + "px)",
                srcset: getPictureUri(source.width.toString(), picture, source.cropName)
            }
        })
}

function renderImage(props: Props): JSX.Element {
    const defaultPicture = props.pictureSetting.defaultPicture;
    const defaultImageUrl = getPictureUri(defaultPicture.width.toString(), props.picture, defaultPicture.cropName);
    const alt = props.picture.alt;
    const title = props.picture.title;
    const className = 'rae-responsive-picture ' + (props.className || '');

    return props.hasPriority ?
        <Image data-cypress={props.dataCypress} className={className}
               alt={getAltText(alt, title)}
               style={props.imageStyle}
               src={defaultImageUrl || ''}
               title={title || ''}
               fill={true}
               priority={true}
        /> :
        <img data-cypress={props.dataCypress} className={(className)} alt={getAltText(alt, title)} style={props.imageStyle}
             src={defaultImageUrl || ''} title={title || ''} loading='lazy'/>
}


export default CCOResponsivePicture;